import React from "react";
import { Link, useLocation } from "react-router-dom";

const title = "join the group";

const WidgetGroupSection = ({ groupList = [], loading = false }) => {
  const location = useLocation();

  const getTargetPath = () => {
    return location.pathname === "/group" ? "/community" : "/group";
  };

  return (
    <div className="widget active-group">
      <div className="widget-inner">
        <div className="widget-title">
          <h5>{title}</h5>
        </div>

        <div className="widget-content">
          {loading ? (
            <p>Loading...</p>
          ) : groupList.length === 0 ? (
            <p>No groups found.</p>
          ) : (
            groupList.map((val, i) => (
              <div className="group-item lab-item" key={i}>
                <div className="lab-inner d-flex flex-wrap align-items-center">
                  <div className="lab-content w-100">
                    <h6>{val.name}</h6>
                    <p>{val.description}</p>

                    <ul className="img-stack d-flex">
                      {val.members?.map((img, idx) => (
                        <li key={idx}>
                          <img
                            src={img.imgUrl?.startsWith('http') || img.imgUrl?.startsWith('/') ? img.imgUrl : `/${img.imgUrl}`}
                            alt="Member"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                            }}
                          />
                        </li>
                      ))}
                      {val.moreCount !== null && (
                        <li className="bg-theme">{val.moreCount}</li>
                      )}
                    </ul>

                    <div className="test">
                      <Link
                        to={getTargetPath()}
                        className="lab-btn"
                        state={{ groupId: val.id }}
                      >
                        <i className="icofont-users-alt-5 me-2"></i> Show More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default WidgetGroupSection;
